@if (feedback().visible) {
  <div class="download-flash" aria-hidden="true"></div>

  <div class="download-toast" [class.download-toast--dark]="darkMode()" role="status" aria-live="polite">
    <span class="download-toast__check" aria-hidden="true">
      <svg viewBox="0 0 52 52" focusable="false">
        <circle class="download-toast__check-circle" cx="26" cy="26" r="24" fill="none" />
        <path class="download-toast__check-mark" fill="none" d="M14 27l7 7 17-17" />
      </svg>
    </span>

    <span class="download-toast__text">
      <strong>{{ 'download.success.title' | translate }}</strong>
      @if (feedback().fileName) {
        <small>{{ feedback().fileName }}</small>
      }
    </span>

    <button type="button" class="download-toast__close" (click)="dismiss()" aria-label="Dismiss notification">
      <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
        <path fill="currentColor" d="m18.3 5.71-1.41-1.41L12 9.17 7.11 4.29 5.7 5.71 10.59 10.6 5.7 15.49l1.41 1.41L12 12.01l4.89 4.89 1.41-1.41-4.89-4.89Z" />
      </svg>
    </button>
  </div>
}
